<div class="loading-screen-wrapper" *ngIf="this.loadingMin==true && session==1">
    <img src="../../../assets/images/loading.gif">
</div>
<div class="loading-screen-wrapper" *ngIf="this.loadingMin2==true && session==2" [ngStyle]="{'width': this.width,'heigth': this.heigth}">
    <img src="../../../assets/images/loading.gif">
</div>